import { CONTACT } from "@/data/site";
import { LogoMark } from "@/components/Logo";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="bg-background border-t border-foreground/15 py-14 md:py-20" data-testid="site-footer">
    <div className="max-w-[1600px] mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <div className="flex items-center gap-4">
            <LogoMark className="h-14 w-auto text-foreground" />
            <div>
              <div className="font-display text-4xl md:text-5xl tracking-tight leading-none">Stainless</div>
              <div className="text-[11px] tracking-[0.3em] uppercase opacity-60 mt-1.5">Drycleaners</div>
            </div>
          </div>
          <p className="mt-4 text-sm font-light text-foreground/75 max-w-sm">
            Premium dry cleaning &amp; fabric care serving {CONTACT.area} for 16 years. Free pickup and delivery to your doorstep.
          </p>
        </div>
        <div className="text-sm font-light text-foreground/80 space-y-1 md:text-right">
          <p><a href={`tel:${CONTACT.phoneTel}`} className="hover:text-foreground transition-colors">{CONTACT.phone}</a></p>
          <p className="max-w-xs md:ml-auto">{CONTACT.address}</p>
          <p>{CONTACT.hours} · Ready in {CONTACT.turnaround}</p>
        </div>
      </div>
      <div className="mt-12 pt-6 border-t border-foreground/15 flex flex-col md:flex-row justify-between gap-3 text-xs uppercase tracking-widest text-foreground/50">
        <span>© {new Date().getFullYear()} Stainless Drycleaners</span>
        <div className="flex items-center gap-6">
          <Link to="/commercial" data-testid="footer-commercial-link" className="hover:text-foreground transition-colors">Commercial</Link>
          <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-foreground transition-colors">Admin</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
